import { Link } from "react-router-dom";
import { treatmentMenuGroups } from "@/mocks/navigation";

export default function TreatmentMegaMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mega-in border-t border-background-300/60 bg-background-100">
      <div className="u-container py-12 lg:py-14">
        <div className="space-y-12 lg:space-y-14">
          {treatmentMenuGroups.map((group) => (
            <div key={group.groupEn}>
              <div className="flex items-baseline gap-5">
                <span className="en-eyebrow text-[11px] text-secondary-700">{group.groupEn}</span>
                <span className="h-px flex-1 bg-foreground-950/10" />
              </div>

              <div className="mt-8 grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-3">
                {group.items.map((item) => (
                  <div key={item.en}>
                    <Link to={item.href} onClick={onNavigate} className="group block">
                      <span className="en-eyebrow block text-[10px] text-foreground-500 transition-colors group-hover:text-foreground-800">
                        {item.en}
                      </span>
                      <span className="mt-2.5 block font-heading text-[16px] text-foreground-950">{item.jp}</span>
                    </Link>
                    <ul className="mt-5 space-y-2.5">
                      {item.links.map((link) => (
                        <li key={link.label}>
                          <Link
                            to={`${item.href}${link.hash}`}
                            onClick={onNavigate}
                            className="group flex items-center gap-3 text-[13px] text-foreground-700 transition-colors hover:text-foreground-950"
                          >
                            <span className="h-px w-3 bg-foreground-950/25 transition-all group-hover:w-5 group-hover:bg-foreground-800" />
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <Link
          to="/#concern"
          onClick={onNavigate}
          className="group mt-12 flex items-center justify-between gap-6 border-t border-foreground-950/10 pt-9"
        >
          <span className="flex flex-col">
            <span className="en-eyebrow text-[11px] text-secondary-700">FIND BY CONCERN</span>
            <span className="mt-3 font-heading text-lg text-foreground-950">
              施術名が分からなくても、お悩みから探せます。
            </span>
          </span>
          <span className="flex shrink-0 items-center gap-2 text-[13px] text-foreground-800 transition-colors group-hover:text-foreground-950">
            お悩みから探す
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
          </span>
        </Link>
      </div>
    </div>
  );
}